import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  inline-size: 100%;

  ${theme.breakpoints.only("tablet")} {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const EmbedIframe = styled("iframe")`
  inline-size: 100%;

  border: 0;
`;
